(function () {
  function loadElfsightIntoReviewsTab() {
    const activeTabButton = document.querySelector('[role="tab"][aria-selected="true"]');

    if (!activeTabButton) return;

    const tabTitle = activeTabButton.textContent?.trim();
    if (tabTitle !== "შეფასებები") return;

    const reviewsTabPanel = document.querySelector(".tabs__content:not([hidden]), .tabs__panel:not([hidden])");

    if (!reviewsTabPanel) return;

    const existingWidget = reviewsTabPanel.querySelector(".elfsight-sapp-01c5b1cb-4a4c-452c-8a61-f3fe65c119fd");
    if (existingWidget) return;

    const div = document.createElement("div");
    div.className = "elfsight-sapp-01c5b1cb-4a4c-452c-8a61-f3fe65c119fd";
    reviewsTabPanel.appendChild(div);
  }

  function loadElfsightAfterTabsSection() {
    var placeholder = document.getElementById("elfsight-reviews-placeholder");
    if (!placeholder) return;

    var existingWidget = placeholder.querySelector(".elfsight-sapp-01c5b1cb-4a4c-452c-8a61-f3fe65c119fd");
    if (existingWidget) return;

    var div = document.createElement("div");
    div.className = "elfsight-sapp-01c5b1cb-4a4c-452c-8a61-f3fe65c119fd";
    placeholder.appendChild(div);

    // Poll until Elfsight renders the widget, then stop
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var rendered = placeholder.querySelector("iframe, .eapps-widget, [data-elfsight-app-lazy]");
      if (rendered || attempts >= 10) {
        clearInterval(poll);
        if (!rendered && attempts >= 10) {
          // Last resort: remove and re-add to trigger Elfsight re-scan
          placeholder.removeChild(div);
          var fresh = document.createElement("div");
          fresh.className = "elfsight-sapp-01c5b1cb-4a4c-452c-8a61-f3fe65c119fd";
          placeholder.appendChild(fresh);
        }
      }
    }, 1000);
  }

  function initElfsightTabLoad() {
    const tabsComponent = document.querySelector("tabs-component");
    const productTabs = document.querySelector("product-tabs");

    function handleTabChange() {
      loadElfsightIntoReviewsTab();
    }

    if (tabsComponent) {
      tabsComponent.addEventListener("tabChange", handleTabChange);
    }

    if (productTabs) {
      productTabs.addEventListener("tabChange", handleTabChange);
    }

    const tabButtons = document.querySelectorAll("[role='tab']");
    tabButtons.forEach(function (button) {
      button.addEventListener("click", handleTabChange, {passive: true});
    });
  }

  function initElfsightScrollLoad() {
    const linkedSection = document.querySelector(
      '[id*="linked_collection"].shopify-section'
    );
    const tabsSection = document.querySelector(
      '[id*="tabs_content"].shopify-section'
    );

    const anchorSection = linkedSection || tabsSection;
    if (!anchorSection) return;

    const placeholder = document.createElement("div");
    placeholder.id = "elfsight-reviews-placeholder";
    placeholder.style.minHeight = "100px";
    anchorSection.parentNode.insertBefore(placeholder, anchorSection.nextSibling);

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.disconnect();
              loadElfsightAfterTabsSection();
            }
          });
        },
        {rootMargin: "200px"}
      );

      observer.observe(anchorSection);
    } else {
      window.addEventListener(
        "scroll",
        function () {
          loadElfsightAfterTabsSection();
        },
        {once: true, passive: true}
      );
    }
  }

  function init() {
    initElfsightTabLoad();
    initElfsightScrollLoad();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, {once: true});
  } else {
    init();
  }
})();
